var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import produce from 'immer';
export var initialState = {
    userInfo: null,
    userInfoLoaded: false,
    category: null,
    categoryData: null,
    selectedImageIndex: 0
};
export var USER_INFO_REQUEST = 'USER_INFO_REQUEST';
export var USER_INFO_SUCCESS = 'USER_INFO_SUCCESS';
export var USER_INFO_FAILURE = 'USER_INFO_FAILURE';
export var CATEGORY_REQUEST = 'CATEGORY_REQUEST';
export var CATEGORY_SUCCESS = 'CATEGORY_SUCCESS';
export var CATEGORY_FAILURE = 'CATEGORY_FAILURE';
export var SET_SELECTED_IMAGE_INDEX = 'SET_SELECTED_IMAGE_INDEX';
var Reducer = function (state, action) {
    if (state === void 0) { state = initialState; }
    return produce(state, function (draft) {
        switch (action.type) {
            case USER_INFO_REQUEST: {
                break;
            }
            case USER_INFO_SUCCESS: {
                draft.userInfo = action.data.isLogin ? action.data.result : null;
                draft.userInfoLoaded = true;
                break;
            }
            case USER_INFO_FAILURE: {
                break;
            }
            case CATEGORY_REQUEST: {
                break;
            }
            case CATEGORY_SUCCESS: {
                var result = action.data.data.result;
                var cate = result.cate || [];
                var objCate_1 = {};
                var dataS_1 = function (cateData) {
                    cateData.forEach(function (v) {
                        objCate_1[v.cate_id] = __assign(__assign({}, v), { child: [] });
                        if (v.child_count > 0) {
                            dataS_1(v.child);
                        }
                    });
                };
                dataS_1(cate);
                draft.category = result.cate;
                draft.categoryData = objCate_1;
                break;
            }
            case CATEGORY_FAILURE: {
                break;
            }
            case SET_SELECTED_IMAGE_INDEX: {
                draft.selectedImageIndex = action.data;
                break;
            }
            default: {
                break;
            }
        }
    });
};
export default Reducer;



//////////////////
// WEBPACK FOOTER
// ./src/detail/reducers/common.ts
// module id = 36
// module chunks = 0